<template>
  <b-col v-if="!hideCreateAssessmentCriteria">
    <b-row align-v="center">
      <router-link :to="createAssessmentPostRoute">
        <b-button
          variant="outline-primary"
          size="sm"
          class="button__create-criteria"
          :disabled="disabled"
        >
          Create an assessment post
        </b-button>
      </router-link>
    </b-row>
  </b-col>
</template>

<script>
import Criteria from '@/models/Criteria';

export default {
  props: {
    sectionId: {
      type: [String, Number],
      required: true
    },

    criterion: {
      type: Criteria,
      default: () => ({})
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    },

    hideCreateAssessmentCriteria: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    createAssessmentPostRoute() {
      return {
        name: 'design-planning/post/create',
        params: { sectionId: this.sectionId },
        query: {
          previousPath: this.$route.fullPath,
          isSubmission: true,
          criteria: [this.criterion.id]
        }
      };
    }
  }
};
</script>
